var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _RootComponent_levelName_accessor_storage;
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { Game } from '../game/game';
import { Sounds } from '../lib/sounds';
export var UIState;
(function (UIState) {
    UIState["Title"] = "title";
    UIState["Customizing"] = "customizing";
    UIState["Game"] = "game";
})(UIState || (UIState = {}));
let RootComponent = class RootComponent extends LitElement {
    get levelName() { return __classPrivateFieldGet(this, _RootComponent_levelName_accessor_storage, "f"); }
    set levelName(value) { __classPrivateFieldSet(this, _RootComponent_levelName_accessor_storage, value, "f"); }
    constructor() {
        super();
        _RootComponent_levelName_accessor_storage.set(this, undefined);
        this.allMovementIds = new Set();
        this.uiState = UIState.Title;
        this.showPicker = false;
        this.hadTouchEvent = false;
        this.game = new Game();
        this.game.onLevelChange = (levelName) => {
            levelName = levelName;
            this.uiState = UIState.Game;
            this.levelName = levelName;
            this.showPicker = !this.game.inputStarted;
        };
        window.game = this.game;
        // Game.preload().then(() => this.skipToGame());
    }
    firstUpdated() {
        this.game.setCanvas(this.shadowRoot?.querySelector('canvas'));
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('touchstart', () => {
            this.hadTouchEvent = true;
            // Try to go fullscreen?
        });
    }
    render() {
        let uiElems = [];
        if (this.uiState === UIState.Title) {
            const title = html `<title-component
                class="fullscreen"
                @hide-title=${() => {
                this.uiState = UIState.Customizing;
                Sounds.setSongs([]);
            }}
            >
            </title-component>`;
            uiElems.push(title);
        }
        if (this.uiState === UIState.Customizing) {
            const customizer = html `<instructions-component
                class="fullscreen"
                @select-customization=${(event) => {
                this.game.playerVisualInfo = event.detail;
                this.game.start();
            }}
            ></instructions-component>`;
            uiElems.push(customizer);
        }
        if (this.uiState === UIState.Game) {
            if (this.showPicker) {
                const picker = html `<player-picker
                    class="fullscreen"
                    levelName="${this.levelName}"
                    @players-selected=${(e) => {
                    this.showPicker = false;
                    const newMovementIds = new Set(this.allMovementIds);
                    for (const player of e.detail) {
                        if (player.id) {
                            newMovementIds.add(player.id);
                        }
                    }
                    this.allMovementIds = newMovementIds;
                    this.game.selectPlayers(e.detail);
                }}
                    .allMovementIds=${this.allMovementIds}
                ></player-picker>`;
                uiElems.push(picker);
            }
            else if (this.hadTouchEvent) {
                uiElems.push(html `<touch-controls
                    @restart=${() => {
                    this.game.restartLevel();
                }}>
                </touch-controls>`);
            }
        }
        return html `
            <canvas class="main-canvas"></canvas>
            ${uiElems}
        `;
    }
    // For quick development
    skipToGame() {
        this.uiState = UIState.Game;
        this.game.playerVisualInfo = {
            player: 'test',
            hairColor: 'Black',
            hairStyle: 'Poofy',
            skinTone: 'Light',
            clothing: 'Blue',
            songTrack: 'melody',
        };
        this.game.start();
    }
};
_RootComponent_levelName_accessor_storage = new WeakMap();
RootComponent.styles = css `
        :host {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100vh;
            width: 100vw;
        }

        .fullscreen {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
        }
    `;
__decorate([
    property({ type: String })
], RootComponent.prototype, "levelName", null);
__decorate([
    state()
], RootComponent.prototype, "allMovementIds", void 0);
__decorate([
    state()
], RootComponent.prototype, "uiState", void 0);
__decorate([
    state()
], RootComponent.prototype, "showPicker", void 0);
__decorate([
    state()
], RootComponent.prototype, "hadTouchEvent", void 0);
RootComponent = __decorate([
    customElement('root-component')
], RootComponent);
export { RootComponent };
// declare global {
//     interface HTMLElementEventMap {
//         'create-canvas': CustomEvent<HTMLCanvasElement>;
//     }
// }
